import { REGEXP_IS_EMAIL_SIMPLE, REGEXP_IS_RUSSIAN_NUMBER } from '@sigma-legacy-libs/essentials/lib/constants/regexp'
import { isUUID } from '@sigmasms/commons'

import { isPhoneNumber, proxy } from '@/utils'

import render from './render'

const excludeSymbolsRegex = /[^a-zA-Z\d_.@+\-,;\s]/gm
const replaceSymbolsRegex = /[,;\s]/gm
const plusDigitRegex = /[^\+\d]/g
const replacePlusSevenRegex = /\+?(7|8)(.*)/

export default {
  name: 'SendingsCreateRecipients',

  mixins: [ proxy({ type: 'object' }) ],

  methods: {
    pasteFilter(value) {
      const separator = '\n'
      const string = value + ''
      const firstReplace = string.replace(excludeSymbolsRegex, '')
      const secondReplace = firstReplace.replace(replaceSymbolsRegex, separator)
      const data = secondReplace.split(separator)

      return this.checkValues(data)
    },

    checkValues(data) {
      return data.reduce((result, item) => {
        let value
        if (isUUID(item) && ~data.indexOf(item)) {
          value = item
        } else if (REGEXP_IS_RUSSIAN_NUMBER.test(item.replace(plusDigitRegex, ''))) {
          value = item.replace(plusDigitRegex, '').replace(replacePlusSevenRegex, '+7$2')
        } else if (REGEXP_IS_EMAIL_SIMPLE.test(item)) {
          value = item
        } else {
          if (isPhoneNumber(item).isValid) {
            value = isPhoneNumber(item).formatted
          }
        }

        if (value && !~result.indexOf(value)) {
          result.push(value)
        }

        return result
      }, [])
    }
  },

  render
}
